import { Player } from './Player';

require('./styles/app.less');

module.exports = Player;
module.exports.version = process.env.VERSION;


// WEBPACK FOOTER //
// ./src/index.js